import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import React from 'react'

const NonMusicalToolTip = () => (
    <CustomToolTip
        title="Non-Musical Work"
        info="When a registered work is categorized as a non-musical work, the registration is marked as non-musical in The MLC database. Non-musical works should not be registered with The MLC. Royalties are not allocated or paid to identified non-musical works."
        place="top"
    />
)

export default NonMusicalToolTip
